import loading from './loading.vue';
export default (Vue) => {
    Vue.customElement('loding-3', loading);
}